var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 11.2H11.91L11.63 10.9299C12.61 9.78995 13.2 8.30995 13.2 6.69995C13.2 3.10995 10.29 0.199951 6.70001 0.199951C3.11001 0.199951 0.200012 3.10995 0.200012 6.69995C0.200012 10.2899 3.11001 13.1999 6.70001 13.1999C8.31001 13.1999 9.79001 12.61 10.93 11.63L11.2 11.91V12.6999L16.2 17.6899L17.69 16.1999L12.7 11.2ZM6.70001 11.2C4.21001 11.2 2.20001 9.18995 2.20001 6.69995C2.20001 4.20995 4.21001 2.19995 6.70001 2.19995C9.19001 2.19995 11.2 4.20995 11.2 6.69995C11.2 9.18995 9.19001 11.2 6.70001 11.2Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2ff1708839a05da84345d28db389ae59.svg";
export { ForwardRef as ReactComponent };